import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  StatusPropostaParceiro,
  StatusPropostaParceiroEnum
} from "../../../aplicacao/enum/status-proposta-parceiro.enum";
import {StatusNegociacao} from "../../../aplicacao/enum/status-negociacao.enum";

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnInit{
  statusPropostaParceiro = StatusPropostaParceiro;
  // statusPropostaParceiro.GerandoOferta
  @Input() informacoes;
  @Input() txtNovo;
  @Input() statusNegociacao;
  @Input() valorAnterior;
  @Input() badgeTotal = false;
  @Input() badgeWidth = 'fit-content';
  @Output() clickModal = new EventEmitter();
  ngOnInit() {
  }
  tipoStatus(): string {
    switch (this.informacoes) {
      case this.statusPropostaParceiro.GerandoOferta:
        return 'bg-warning';
      case this.statusPropostaParceiro.AguardandoAceite:
        return 'bg-orange text-black';
      case this.statusPropostaParceiro.EmAndamento:
        return 'bg-warning  text-white';
      case this.statusPropostaParceiro.Pago:
        return 'bg-success text-white';
      case this.statusPropostaParceiro.Reprovada:
        return 'bg-cinza-noite text-white';
      case this.statusPropostaParceiro.Pendente:
        return 'bg-danger text-white';
      case this.statusPropostaParceiro.AguardandoCnd:
        return 'bg-orange text-black';
      case this.statusPropostaParceiro.DocumentoPendente:
        return 'bg-orange text-black';
      case this.statusPropostaParceiro.Aprovada:
        return 'bg-success text-white';
      case this.statusPropostaParceiro.AguardandoProposta:
        return 'bg-warning';
      case this.statusPropostaParceiro.AguardandoDisponibilidade:
        return 'bg-warning';
      case this.statusPropostaParceiro.ValidandoDocumento:
        return 'bg-warning';
      case this.statusPropostaParceiro.PropostaVencida:
        return 'bg-cinza-noite';
      case this.statusPropostaParceiro.ContatoComCliente:
        return 'bg-warning';
      default:
        return 'bg-info text-white';
    }
  }

  corTexto(): string {
    if(this.informacoes === this.statusPropostaParceiro.EmAndamento ||
      this.informacoes === this.statusPropostaParceiro.GerandoOferta ||
      this.informacoes === this.statusPropostaParceiro.AguardandoProposta ||
      this.informacoes === this.statusPropostaParceiro.AguardandoDisponibilidade ||
      this.informacoes === this.statusPropostaParceiro.AguardandoAceite ||
      this.informacoes === this.statusPropostaParceiro.DocumentoPendente ||
      this.informacoes === this.statusPropostaParceiro.ValidandoDocumento ||
      this.informacoes === this.statusPropostaParceiro.ContatoComCliente ||
      this.informacoes === this.statusPropostaParceiro.AguardandoCnd) {
      return;
    } else {
      return 'text-white';
    }
  }

  tipoTexto(): string {
    switch (this.informacoes) {
      case this.statusPropostaParceiro.GerandoOferta:
        return 'Verificando viabilidade';
      case this.statusPropostaParceiro.AguardandoAceite:
        if(this.statusNegociacao === StatusNegociacao.NovaOfertaPjus) {
          if (this.valorAnterior === 0) {
            return 'Proposta enviada';
          } else {
            return 'A PJUS enviou uma contraproposta!';
          }
        } else if (this.statusNegociacao === StatusNegociacao.AceiteContraOferta) {
          return 'Sua oferta foi aprovada!';
        } else if (this.statusNegociacao === StatusNegociacao.RecusaContraOferta) {
          return 'A PJUS reprovou sua contraproposta';
        } else {
          return 'Proposta enviada';
        }
      case this.statusPropostaParceiro.EmAndamento:
        return 'Em andamento';
      case this.statusPropostaParceiro.Pago:
        return 'Pago';
      case this.statusPropostaParceiro.Reprovada:
        return 'Reprovada';
      case this.statusPropostaParceiro.Aprovada:
        return 'Aprovada - Aguardando aceite';
      case this.statusPropostaParceiro.Pendente:
        return 'Aguardando documentos';
      case this.statusPropostaParceiro.AguardandoCnd:
        return 'Aguardando documentos';
      case this.statusPropostaParceiro.DocumentoPendente:
        return 'Erro no envio de documentos';
      case this.statusPropostaParceiro.AguardandoProposta:
        if(this.statusNegociacao === StatusNegociacao.GerandoOferta) {
          return 'Analisando contraproposta';
        } else {
          return 'Aguardando proposta';
        }
      case this.statusPropostaParceiro.AguardandoDisponibilidade:
        return 'Aguardando disponibilidade';
      case this.statusPropostaParceiro.ValidandoDocumento:
        return 'Análise de documentos';
      case this.statusPropostaParceiro.PropostaVencida:
        return 'Proposta vencida';
      case this.statusPropostaParceiro.ContatoComCliente:
        return 'Alteração no valor';
      default:
        return '-';
    }
  }

  chamarModal(): void {
    this.clickModal.emit();
  }
}
